/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_changing_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changing Password...`)
};

const zh_hans1_settings_changing_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修改密码中...`)
};

const zh_hant1_settings_changing_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`變更密碼中…`)
};

const fr_settings_changing_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changement du mot de passe…`)
};

const de_settings_changing_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort wird geändert…`)
};

const ja_settings_changing_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードを変更中…`)
};

const ko_settings_changing_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호 변경 중...`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_changing_password = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_changing_password(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_changing_password", locale)
	if (locale === "en") return en_settings_changing_password(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_changing_password(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_changing_password(inputs)
	if (locale === "fr") return fr_settings_changing_password(inputs)
	if (locale === "de") return de_settings_changing_password(inputs)
	if (locale === "ja") return ja_settings_changing_password(inputs)
	return ko_settings_changing_password(inputs)
};